import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'rotate', 'IconRotate', [["path",{"d":"M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5","key":"svg-0"}]]);